export default __webpack_public_path__ + "2de0b6b436b98d817193c1429e69337f.png";